import MutateSponsorship from "./MutateSponsorship";

export default MutateSponsorship